// extracted by css-extract-rspack-plugin
export default {"tagContainer":"Ye08tP1t","tagSmall":"cQ5FIz0F","tagDefault":"ASjCdaKU","bgTag":"iuEkNMrU","bgTagDisabled":"iN6wRfaB","bgTagInverted":"su_m_xzM","bgTagSecondary":"bBs4c7NX"};